/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ModifyTenantConfigCmd } from '../../models/modify-tenant-config-cmd';
import { ValidationError } from '../../models/validation-error';

export interface UpdateTenantConfig$Params {
  id: string;
  key: 'MAX_CONFIGURED_USERS' | 'MAX_CONCURRENT_SESSIONS' | 'USER_REACTIVATION_GRACE_HOURS' | 'SHOULD_SEND_NOTIFICATION' | 'SHOULD_SEND_REMINDER';
      body?: ModifyTenantConfigCmd
}

export function updateTenantConfig(http: HttpClient, rootUrl: string, params: UpdateTenantConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
  const rb = new RequestBuilder(rootUrl, updateTenantConfig.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('key', params.key, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ValidationError>>;
    })
  );
}

updateTenantConfig.PATH = '/api/tenants/{id}/configs/{key}';
